import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useFetchContent from './useFetchContent';
import SearchInfoPage from './SearchInfoPage';

const ProductInfo = () => {
  const { productId: urlProductId } = useParams();
  const [productId, setProductId] = useState(urlProductId);
  const navigate = useNavigate();

  useEffect(() => {
    setProductId(urlProductId);
  }, [urlProductId]);

  const formatAge = (age) => {
    if (age >= 60) return `${age / 12} lat`;
    if (age >= 24) return `${age / 12} lata`;
    return `${age} miesięcy`;
  };

  const formatAgeForInstruction = (age) => {
      if (/lat(a)?/.test(age)) return age;
      if (age >= 60) return `${age / 12} lat`;
      if (age >= 24) return `${age / 12} lata`;
      return `${age} miesięcy`;
    };

  const transformData = (product) => ({
    title: product[1],
    sections: [
      { label: 'Od jakiego wieku?', value: formatAge(product[2]) },
      { label: 'Czy jest popularnym alergenem?', value: product[3] },
      { label: 'Opis', value: product[5] },
      {
        label: 'Czy istnieje ryzyko zakrztuszenia?',
        value: product[4],
      },
      {
        label: 'W jakiej formie podawać?',
        value: JSON.parse(product[6]).map((item, index) => (
          <div key={index} style={{ marginBottom: '20px' }}>
            <b>+{formatAgeForInstruction(item.age)}</b>
            <div>{item.instruction}</div>
          </div>
        )),
      },
    ],
  });

  const { contentSections, isLoading, error, setError } = useFetchContent(false, productId, transformData);

  const handleSearch = (newProductId) => {
    navigate(`/encyklopedia/${newProductId}`);
  };

  return (
    <SearchInfoPage
      isLoading={isLoading}
      productId={productId}
      setProductId={handleSearch}
      title="Encyklopedia Produktów"
      searchPlaceholder="Wyszukaj produkt..."
      contentSections={contentSections}
      error={error}
      setError={setError}
    />
  );
};

export default ProductInfo;